import { render, staticRenderFns } from "./OutClinicInvoice.vue?vue&type=template&id=336c253e&scoped=true"
import script from "./OutClinicInvoice.vue?vue&type=script&lang=js"
export * from "./OutClinicInvoice.vue?vue&type=script&lang=js"
import style0 from "./OutClinicInvoice.vue?vue&type=style&index=0&id=336c253e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c253e",
  null
  
)

export default component.exports